angular.module("EventsApp").factory("OpenEventsFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/articles/civi-open-events/:event_id', {event_id: '@event_id'}, {
        get: {
            method: 'GET'
        },
        delete: {
            method: 'DELETE'
        }
    });
}]);